import { render, staticRenderFns } from "./ConfidentialityReminderDialog.vue?vue&type=template&id=02800fc6&scoped=true&"
import script from "./ConfidentialityReminderDialog.vue?vue&type=script&lang=js&"
export * from "./ConfidentialityReminderDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConfidentialityReminderDialog.vue?vue&type=style&index=0&id=02800fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02800fc6",
  null
  
)

export default component.exports